import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'http.service';
import { ADD_TOAST_MESSAGE } from 'Redux/Enums/Contracts.Globals.Enums';

export const useFetchAppointmentPdf = (year, type, appointmentId, setPdf) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		let didCancel = false;

		const fetchData = async () => {
			try {
				setIsLoading(true);

				if (!appointmentId) {
					dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'error', message: `Appointment ID ${appointmentId} invalid` } });
					return;
				}

				let { status, data } = await axios.get(`/api/v2/release/preex6/pdf/${year}/${type}/${appointmentId}`, {
					responseType: 'arraybuffer',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/pdf'
					}
				});

				if (!didCancel) {
					if (status !== 200 || !data) {
						setIsSuccess(false);
						dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'error', message: `Unable to retrieve PDF ${status}` } });
						return;
					}

					let pdf = Buffer.from(data, 'binary').toString('base64');

					if (pdf) {
						setPdf(pdf);
						setIsSuccess(true);
					} else {
						dispatch({
							type: ADD_TOAST_MESSAGE,
							payload: { severity: 'error', message: `Unable to create PDF for Appointment: ${appointmentId}` }
						});
					}
				}
			} catch (error) {
				dispatch({ type: 'ADD_TOAST_MESSAGE', payload: { severity: 'error', message: error.message } });
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();

		return () => {
			didCancel = true;
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [year, type, appointmentId, setPdf]);
	return { isLoading, isSuccess };
};

export const useFetchTAndCPdf = (year, contractGrouping, type, setPdf) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		const fetchData = async () => {
			try {
				setIsLoading(true);

				let apptType = '';
				if (contractGrouping === 'Ad Hoc') {
					apptType = type;
				}

				let pdf = null;
				const termLink = await axios.get(`/api/v2/release/preex6/termLink/${year}/${contractGrouping}?type=${apptType}`);
				if (termLink) {
					const termLinkId = parseInt(termLink.data.split('/')[4]);
					let result = await axios.get(`/api/v2/release/preex6/${termLinkId}`, {
						responseType: 'arraybuffer',
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/pdf'
						}
					});
					if (result) {
						const data = result.data;
						if (data) {
							pdf = Buffer.from(data, 'binary').toString('base64');
							setPdf(pdf);
							setIsSuccess(true);
						}
						setIsLoading(false);
					}
				}

				if (!termLink || !pdf) {
					dispatch({
						type: ADD_TOAST_MESSAGE,
						payload: { severity: 'error', message: 'Unable to create PDF' }
					});
				}
			} catch (error) {
				dispatch({ type: 'ADD_TOAST_MESSAGE', payload: { severity: 'error', message: error.message } });
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [year, contractGrouping, type, setPdf]);
	return { isLoading, isSuccess };
};
